// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ══════════════════════════════════════════════════════════
   AddonGate — Upsell landing page styles
   ══════════════════════════════════════════════════════════ */

.addon-gate-upsell {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #f5f7fa;
  font-family: inherit;
}

/* ── Hero ─────────────────────────────────────────────── */
.addon-gate-hero {
  background: linear-gradient(135deg, #0d1b3e 0%, #1a3a6e 50%, #1e5fbc 100%);
  color: #fff;
  padding: 48px 32px 56px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.addon-gate-hero::before {
  content: "";
  position: absolute;
  top: -60px;
  right: -60px;
  width: 260px;
  height: 260px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.04);
  pointer-events: none;
}

.addon-gate-hero::after {
  content: "";
  position: absolute;
  bottom: -80px;
  left: -40px;
  width: 320px;
  height: 320px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.03);
  pointer-events: none;
}

.addon-gate-icon-wrap {
  width: 72px;
  height: 72px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.addon-gate-icon-wrap svg {
  color: #fff;
}

.addon-gate-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.3);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: #a8c8ff;
  margin-bottom: 16px;
}

.addon-gate-title {
  font-size: 28px;
  font-weight: 800;
  margin: 0 0 10px;
  line-height: 1.2;
}

.addon-gate-subtitle {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.75);
  max-width: 480px;
  margin: 0 auto 32px;
  line-height: 1.6;
}

/* ── Stats row ───────────────────────────────────────── */
.addon-gate-stats {
  display: flex;
  gap: 32px;
  justify-content: center;
  flex-wrap: wrap;
  position: relative;
  z-index: 1;
}

.addon-gate-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.addon-gate-stat-num {
  font-size: 24px;
  font-weight: 800;
  color: #fff;
}

.addon-gate-stat-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 2px;
}

/* ── Feature cards ───────────────────────────────────── */
.addon-gate-body {
  padding: 40px 24px 48px;
  max-width: 860px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
}

.addon-gate-section-title {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #8a94a6;
  margin-bottom: 20px;
  text-align: center;
}

.addon-gate-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
  margin-bottom: 40px;
}

.addon-gate-card {
  background: #fff;
  border-radius: 14px;
  padding: 24px 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  border: 1px solid #eaecf0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.addon-gate-card-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #eef3ff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1e5fbc;
}

.addon-gate-card-label {
  font-size: 14px;
  font-weight: 700;
  color: #1a2236;
}

.addon-gate-card-desc {
  font-size: 13px;
  color: #6b7280;
  line-height: 1.5;
}

/* ── CTA buttons ─────────────────────────────────────── */
.addon-gate-cta {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

.addon-gate-btn-primary {
  padding: 13px 28px;
  border-radius: 10px;
  background: #1e5fbc;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  transition: background 0.18s;
}

.addon-gate-btn-primary:hover {
  background: #1a4fa0;
}

.addon-gate-btn-secondary {
  padding: 13px 28px;
  border-radius: 10px;
  background: #fff;
  color: #1e5fbc;
  font-size: 15px;
  font-weight: 700;
  border: 2px solid #1e5fbc;
  cursor: pointer;
  transition: background 0.18s, color 0.18s;
}

.addon-gate-btn-secondary:hover {
  background: #eef3ff;
}

/* ── Dark mode ───────────────────────────────────────── */
.dark .addon-gate-upsell {
  background: #121827;
}

.dark .addon-gate-card {
  background: #1e2a3a;
  border-color: #2e3d52;
}

.dark .addon-gate-card-label {
  color: #e2e8f0;
}

.dark .addon-gate-card-desc {
  color: #94a3b8;
}

.dark .addon-gate-section-title {
  color: #64748b;
}

.dark .addon-gate-btn-secondary {
  background: #1e2a3a;
  color: #a8c8ff;
  border-color: #3b5998;
}

.dark .addon-gate-btn-secondary:hover {
  background: #263348;
}

.dark .addon-gate-card-icon {
  background: #1a3260;
  color: #7eb3ff;
}

/* ── Back Button ─────────────────────────────────────── */
.addon-gate-back-btn {
  position: fixed;
  top: 24px;
  left: 24px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.85);
  border: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #1e5fbc;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  z-index: 1000;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.addon-gate-back-btn:hover {
  background-color: rgba(255, 255, 255, 0.95);
  border-color: rgba(0, 0, 0, 0.15);
  transform: translateX(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}

.addon-gate-back-btn svg {
  width: 20px;
  height: 20px;
}

/* Dark mode back button */
.dark .addon-gate-back-btn {
  background-color: rgba(30, 42, 58, 0.85);
  border-color: rgba(255, 255, 255, 0.1);
  color: #7eb3ff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.dark .addon-gate-back-btn:hover {
  background-color: rgba(38, 51, 72, 0.95);
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);
}


`, "",{"version":3,"sources":["webpack://./client/src/components/AddonGate/index.css"],"names":[],"mappings":"AAAA;;+DAE+D;;AAE/D;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,4DAA4D;AAC5D;EACE,0EAA0E;EAC1E,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,eAAe;AACjB;;AAEA,2DAA2D;AAC3D;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,0CAA0C;EAC1C,aAAa;EACb,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,2CAA2C;EAC3C,iCAAiC;EACjC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,wCAAwC;EACxC,sCAAsC;EACtC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;EACxC,sCAAsC;EACtC,yCAAyC;AAC3C","sourcesContent":["/* ══════════════════════════════════════════════════════════\n   AddonGate — Upsell landing page styles\n   ══════════════════════════════════════════════════════════ */\n\n.addon-gate-upsell {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background: #f5f7fa;\n  font-family: inherit;\n}\n\n/* ── Hero ─────────────────────────────────────────────── */\n.addon-gate-hero {\n  background: linear-gradient(135deg, #0d1b3e 0%, #1a3a6e 50%, #1e5fbc 100%);\n  color: #fff;\n  padding: 48px 32px 56px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.addon-gate-hero::before {\n  content: \"\";\n  position: absolute;\n  top: -60px;\n  right: -60px;\n  width: 260px;\n  height: 260px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.04);\n  pointer-events: none;\n}\n\n.addon-gate-hero::after {\n  content: \"\";\n  position: absolute;\n  bottom: -80px;\n  left: -40px;\n  width: 320px;\n  height: 320px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.03);\n  pointer-events: none;\n}\n\n.addon-gate-icon-wrap {\n  width: 72px;\n  height: 72px;\n  border-radius: 20px;\n  background: rgba(255, 255, 255, 0.12);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 20px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.addon-gate-icon-wrap svg {\n  color: #fff;\n}\n\n.addon-gate-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 20px;\n  background: rgba(255, 255, 255, 0.15);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 1.2px;\n  text-transform: uppercase;\n  color: #a8c8ff;\n  margin-bottom: 16px;\n}\n\n.addon-gate-title {\n  font-size: 28px;\n  font-weight: 800;\n  margin: 0 0 10px;\n  line-height: 1.2;\n}\n\n.addon-gate-subtitle {\n  font-size: 15px;\n  color: rgba(255, 255, 255, 0.75);\n  max-width: 480px;\n  margin: 0 auto 32px;\n  line-height: 1.6;\n}\n\n/* ── Stats row ───────────────────────────────────────── */\n.addon-gate-stats {\n  display: flex;\n  gap: 32px;\n  justify-content: center;\n  flex-wrap: wrap;\n  position: relative;\n  z-index: 1;\n}\n\n.addon-gate-stat {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.addon-gate-stat-num {\n  font-size: 24px;\n  font-weight: 800;\n  color: #fff;\n}\n\n.addon-gate-stat-label {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.6);\n  margin-top: 2px;\n}\n\n/* ── Feature cards ───────────────────────────────────── */\n.addon-gate-body {\n  padding: 40px 24px 48px;\n  max-width: 860px;\n  margin: 0 auto;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.addon-gate-section-title {\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  color: #8a94a6;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.addon-gate-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 16px;\n  margin-bottom: 40px;\n}\n\n.addon-gate-card {\n  background: #fff;\n  border-radius: 14px;\n  padding: 24px 20px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);\n  border: 1px solid #eaecf0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.addon-gate-card-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  background: #eef3ff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #1e5fbc;\n}\n\n.addon-gate-card-label {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1a2236;\n}\n\n.addon-gate-card-desc {\n  font-size: 13px;\n  color: #6b7280;\n  line-height: 1.5;\n}\n\n/* ── CTA buttons ─────────────────────────────────────── */\n.addon-gate-cta {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.addon-gate-btn-primary {\n  padding: 13px 28px;\n  border-radius: 10px;\n  background: #1e5fbc;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 700;\n  border: none;\n  cursor: pointer;\n  transition: background 0.18s;\n}\n\n.addon-gate-btn-primary:hover {\n  background: #1a4fa0;\n}\n\n.addon-gate-btn-secondary {\n  padding: 13px 28px;\n  border-radius: 10px;\n  background: #fff;\n  color: #1e5fbc;\n  font-size: 15px;\n  font-weight: 700;\n  border: 2px solid #1e5fbc;\n  cursor: pointer;\n  transition: background 0.18s, color 0.18s;\n}\n\n.addon-gate-btn-secondary:hover {\n  background: #eef3ff;\n}\n\n/* ── Dark mode ───────────────────────────────────────── */\n.dark .addon-gate-upsell {\n  background: #121827;\n}\n\n.dark .addon-gate-card {\n  background: #1e2a3a;\n  border-color: #2e3d52;\n}\n\n.dark .addon-gate-card-label {\n  color: #e2e8f0;\n}\n\n.dark .addon-gate-card-desc {\n  color: #94a3b8;\n}\n\n.dark .addon-gate-section-title {\n  color: #64748b;\n}\n\n.dark .addon-gate-btn-secondary {\n  background: #1e2a3a;\n  color: #a8c8ff;\n  border-color: #3b5998;\n}\n\n.dark .addon-gate-btn-secondary:hover {\n  background: #263348;\n}\n\n.dark .addon-gate-card-icon {\n  background: #1a3260;\n  color: #7eb3ff;\n}\n\n/* ── Back Button ─────────────────────────────────────── */\n.addon-gate-back-btn {\n  position: fixed;\n  top: 24px;\n  left: 24px;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: rgba(255, 255, 255, 0.85);\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: #1e5fbc;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  z-index: 1000;\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n}\n\n.addon-gate-back-btn:hover {\n  background-color: rgba(255, 255, 255, 0.95);\n  border-color: rgba(0, 0, 0, 0.15);\n  transform: translateX(-2px);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);\n}\n\n.addon-gate-back-btn svg {\n  width: 20px;\n  height: 20px;\n}\n\n/* Dark mode back button */\n.dark .addon-gate-back-btn {\n  background-color: rgba(30, 42, 58, 0.85);\n  border-color: rgba(255, 255, 255, 0.1);\n  color: #7eb3ff;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.dark .addon-gate-back-btn:hover {\n  background-color: rgba(38, 51, 72, 0.95);\n  border-color: rgba(255, 255, 255, 0.2);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
